/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const zh_hans1_settings_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const zh_hant1_settings_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續`)
};

const fr_settings_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const de_settings_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const ja_settings_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続行`)
};

const ko_settings_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_continue = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_continue(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_continue", locale)
	if (locale === "en") return en_settings_continue(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_continue(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_continue(inputs)
	if (locale === "fr") return fr_settings_continue(inputs)
	if (locale === "de") return de_settings_continue(inputs)
	if (locale === "ja") return ja_settings_continue(inputs)
	return ko_settings_continue(inputs)
};